module.exports = __webpack_public_path__ + "static/media/bg-about-us.7f0ed865.jpg";